import React, { useState, useEffect, useCallback } from "react";
import { Form, Formik, Field } from "formik";
import { useHistory } from 'react-router-dom';
import * as moment from "moment";
import { getPostInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/requestPickupOrderUtils";
import { adminFetchLocationListApi } from "redux/actions/adminPtPlusOrderRequests";
import { fetchPickupLocationListApi } from 'redux/actions/adminPtPlus/index';
import NumberInput from "web/components/form-elements/NumberInput";
import DatePickerPTPlus from "web/components/form-elements/DatePickerPTPlus";
import TimePickerInput from "web/components/form-elements/TimePickerInput"
import TextInput from "web/components/form-elements/TextInput";
import TextArea from "web/components/form-elements/TextArea";
import RadioButton from "web/components/form-elements/RadioButton";
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from "web/components/AlertModal";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import DropDown from "web/components/DropDown";
import Layout from "web/components/Layout";
import Spinner from 'web/components/Spinner';
import { Container, Wrapper, TopHeader, Footer, FormWrapper, DatePickerStyled, InputFieldsWrapper } from "./RequestPickupOrderStyled"
import { createOrder, fetchEditOrderApi, updateOrder } from "redux/actions/requestOrderPtplus";
import { logoutClearRedux } from 'redux/actions/auth';
import { stateConvert } from "web/components/utils/stateAbbreviation";

const PickupOrderRequest = (props) => {
  const token = localStorage.getItem("token")
  let history = useHistory()
  const dispatch = useDispatch();
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [loader, setLoader] = useState(false)
  const storedData = useSelector((state) => state.storedData.payload);
  const customerId = localStorage.getItem("locationID")
  const loadingReqList = [{ value: "LIVE_LOAD", label: 'Live Load' },
  { value: "DROP_TRAILER", label: 'Drop Trailer' },]
  const [editedValues, setEditedValues] = useState()
  const [lastChangedTime, setLastChangedTime] = useState()

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const [alertType, setAlertType] = useState();
  const toggleModal = () => setModal(!modal);

  const [selectedCompanyCustomerId, setSelectedCompanyCustomerId] = useState()
  const [locationListResponse, setLocationListResponse] = useState();
  const [companyNameResponse, setCompanyNameResponse] = useState();

  const [locationAddress, setLocationAddress] = useState();
  const [getLocationAddressState, setLocationAddressState] = useState();

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!token) {
      history.push('./sign-in')
      window.location.reload(false);
    } else {
      locationListAPI()
    }
  }, []);

  const locationListAPI = useCallback(async () => {
    if (token === null) {
      history.push('./sign-in')
      window.location.reload(false);
    } else {
      setLoader(true)
      let response = await dispatch(adminFetchLocationListApi(customerId, token));
      if (response?.success) {
        setLoader(false)
        let locationTemp = response?.data?.customerAndLocations;
        let arr = [];
        for (let i = 0; i < locationTemp.length; i++) {
          let obj = {
            label: locationTemp[i].customer + ' - ' + locationTemp[i].city + ', ' + locationTemp[i].state + ', ' + locationTemp[i].zip,
            value: locationTemp[i].customerId,
            arrList: locationTemp[i].locationIdAndNames
          };
          arr.push(obj);

          if (i === locationTemp.length - 1) {
            setCompanyNameResponse(arr)
          }
        }

        // executed during edit operation
        const ordRefNoForFetchReqPickOrd = localStorage.getItem('ordRefNoForFetchReqPickOrd')
        if (ordRefNoForFetchReqPickOrd) fetchEditOrderDetails(ordRefNoForFetchReqPickOrd)
      } else {
        setLoader(false)
        if (response?.data?.error?.message === 'Invalid Token') {
          history.push('./sign-in')
        } else {
          setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!');
          setModalLink("");
          toggleModal();
        }
      }
    }
  }, []);

  const fetchEditOrderDetails = async (ordRefNoForFetchReqPickOrd) => {
    let response = await dispatch(fetchEditOrderApi(ordRefNoForFetchReqPickOrd, token));
    if (response.data?.success) {
      setEditedValues(response.data?.data)
    }
  }

  const getLocationAddress = async (customerId) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(fetchPickupLocationListApi(customerId, token));
      let arr = []
      if (response?.success) {
        if (response?.data?.locations[0]?.mainLocation) {
          let obj = {
            locationId: response?.data?.locations[0]?.mainLocation?.locationId,
            address: response?.data?.locations[0]?.mainLocation?.address
          }
          arr.push(obj)
        }
        if (response?.data?.locations[0]?.subLocations) {
          for (let i = 0; i < response?.data?.locations[0]?.subLocations.length; i++) {
            let obj = {
              locationId: response?.data?.locations[0]?.subLocations[i]?.locationId,
              address: response?.data?.locations[0]?.subLocations[i]?.address
            }
            arr.push(obj)
          }
        }
        setLocationAddressState(arr)
        if (arr && arr.length > 0) {
          const locListTemp = arr.map(item => ({
            label: item.address?.locationName + ' - ' + item.address?.city + ', ' + (stateConvert(item.address?.state) || item.address?.state) + ', ' + item.address?.zipCode,
            value: item.locationId,
          }));
          setLocationListResponse(locListTemp);
        }
        if (editedValues) setLocationAddressFunction(arr, editedValues?.locationId)
      } else {
        setModalContent(response?.data?.error?.message);
        setModalLink("");
        toggleModal();
      }
    }
  }

  const formSubmit = async (props) => {
    const { values } = props

    if (values.reqPickupQuantity === 0 || values.reqPickupQuantity === '0') {
      setModalTitle("")
      setModalContent('Please select a quantity greater than 0.');
      setModalLink("");
      toggleModal();
      return
    }

    let data = {
      emailId: [localStorage.getItem('email')],
      locationName: localStorage.getItem('companyName'),
      loadingRequirement: values.loadingReq !== '' ? values.loadingReq : null,
      loadDetails: {
        requestPickupDate: moment(values.ptplusOrderReqPickupDate).format('YYYY-MM-DD HH:mm'),
        deliveryFromtime: values.appFromTime,
        deliveryTotime: values.appToTime,
        poNumber: values.poNumber,
        quantity: values.reqPickupQuantity,
      },
      location: {
        locationId: values.businessName,
        shippingAddress: locationAddress
      },
      customer: { customerId: selectedCompanyCustomerId },
      comment: values.comments
    }

    if (editedValues) data.orderRefNumber = editedValues.orderRefNumber

    let response
    if (editedValues) response = await dispatch(updateOrder(data, token))
    else response = await dispatch(createOrder(data, token));
    if (response?.data?.success) {
      setModalTitle("")
      setModalContent(editedValues ? 'Pickup order request updated successfully!' : 'Pickup order requested successfully!');
      setModalLink("");
      toggleModal();
      setAlertType('success')
    } else {
      setModalContent(response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.');
      setModalLink("");
      toggleModal();
    }
  }

  const resetFields = props => {
    const { setFieldValue } = props
    let reqDefaultPickupDate = moment(new Date().setDate(new Date().getDate() + 4)).format('MM/DD/YYYY')
    setFieldValue('companyName', '')
    setFieldValue('businessName', '')
    setFieldValue('loadingReq', '')
    setFieldValue('reqPickupQuantity', '')
    setFieldValue('ptplusOrderReqPickupDate', reqDefaultPickupDate)
    setFieldValue('appFromTime', '00:00')
    setFieldValue('appToTime', '23:00')
    setFieldValue('poNumber', '')
    setFieldValue('comments', '')
  }

  const checkDisable = props => {
    const { values } = props
    if (editedValues) {
      let initialEditValues = {
        companyName: editedValues?.customer?.customerId,
        businessName: editedValues?.locationId,
        loadingReq: editedValues?.loadingRequirement,
        reqPickupQuantity: editedValues?.loadDetails?.quantity?.toString(),
        ptplusOrderReqPickupDate: moment(editedValues?.loadDetails?.requestPickupDate).format('MM/DD/YYYY'),
        appFromTime: editedValues?.loadDetails?.deliveryFromtime,
        appToTime: editedValues?.loadDetails?.deliveryTotime,
        poNumber: editedValues?.loadDetails?.poNumber,
        comments: editedValues?.comment
      };
      let isModified = Object.keys(props.values).some(field => props.values[field] !== initialEditValues[field])
      if (!isModified) return true
    }
    let fromTimeValue = parseInt(props.values.appFromTime?.replace(":", ""));
    let toTimeValue = parseInt(props.values.appToTime?.replace(":", ""));
    if (values.businessName === '' || values.loadingReq === '' || values.reqPickupQuantity === '' || errorMessage || (toTimeValue <= fromTimeValue)) return true
    else return false
  }

  const setBusinessNamesList = cusId => {
    getLocationAddress(cusId)
    setSelectedCompanyCustomerId(cusId)
    let businessListOfSelectedCompany = companyNameResponse.filter(data => data.value === cusId)
    if (businessListOfSelectedCompany && businessListOfSelectedCompany[0].arrList.length !== 0) {
      const arr = (businessListOfSelectedCompany[0]?.arrList || []).map(item => ({
        label: item.locationName + ' - ' + item?.city + ', ' + item?.state + ', ' + item?.zipCode,
        value: item.locationId,
      }));
      setLocationListResponse(arr);
    }
  }

  const setLocationAddressFunction = (getLocationAddressState, locationId) => {
    if (getLocationAddressState) {
      for (let i = 0; i < getLocationAddressState.length; i++) {
        if (locationId === getLocationAddressState[i].locationId) {
          setLocationAddress(getLocationAddressState[i].address)
        }
      }
    }
  }

  const setEditedValuesFunction = props => {
    const { setFieldValue } = props
    const ordRefNoForFetchReqPickOrd = localStorage.getItem('ordRefNoForFetchReqPickOrd')
    if (editedValues && ordRefNoForFetchReqPickOrd) {
      setFieldValue('companyName', editedValues?.customer?.customerId)
      setBusinessNamesList(editedValues?.customer?.customerId)
      setFieldValue('businessName', editedValues?.locationId)
      setFieldValue('loadingReq', (editedValues?.loadingRequirement || ''))
      setFieldValue('reqPickupQuantity', editedValues?.loadDetails?.quantity.toString())
      setFieldValue('ptplusOrderReqPickupDate', moment(editedValues?.loadDetails?.requestPickupDate).format('MM/DD/YYYY'))
      setFieldValue('appFromTime', editedValues?.loadDetails?.deliveryFromtime)
      setFieldValue('appToTime', editedValues?.loadDetails?.deliveryTotime)
      setFieldValue('poNumber', editedValues?.loadDetails?.poNumber)
      setFieldValue('comments', editedValues?.comment)
      localStorage.removeItem('ordRefNoForFetchReqPickOrd')
    }
  }

  const isTimeErrorCheck = (props, type) => {
    let fromTimeValue = parseInt(props.values?.appFromTime?.replace(":", ""));
    let toTimeValue = parseInt(props.values?.appToTime?.replace(":", ""));
    if (toTimeValue <= fromTimeValue) return <p style={{ position: 'absolute', fontSize: '12px', color: '#f77171', bottom: '-24px' }}>Invalid Time</p>
  }

  const formFields = (props, isValid, dirty, setFieldValue) => {
    return (
      <>
        <Form className="form-wrapper">
          <FormWrapper>
            <div className="label-heading">
              <p style={{ marginBottom: 0 }}>Pickup Location</p>
            </div>
            <div>
              <InputFieldsWrapper>
                <div>
                  <div className="business-name-wrapper">
                    <div className="app-input-text mb-20" style={{ width: "500px", "margin-bottom": "22px" }}>
                      <DropDown
                        name="companyName"
                        data={companyNameResponse ? companyNameResponse : []}
                        searchDropDown={props.values?.companyName}
                        searchable={true}
                        placeholder="Select Company Name*"
                        disabled={editedValues ? true : false}
                        onChangeHandler={(data) => {
                          props.setFieldValue('companyName', data.value)
                          getLocationAddress(data?.value)
                          let arr = [];
                          setSelectedCompanyCustomerId(data.value)
                          // if (data?.arrList.length !== 0) {
                          //   const arr = (data?.arrList || []).map(item => ({
                          //     label: item.locationName,
                          //     value: item.locationId,
                          //   }));
                          //   setLocationListResponse(arr);
                          // }
                        }}
                      />
                    </div>
                    <div className="app-input-text mb-20" style={{ width: "500px", "margin-bottom": "22px" }}>
                      <DropDown
                        name="businessName"
                        data={locationListResponse ? locationListResponse : []}
                        searchDropDown={props.values?.businessName}
                        searchable={true}
                        disabled={(editedValues || (getLocationAddressState && getLocationAddressState?.length < 1)) ? true : false}
                        placeholder="Business Name*"
                        onChangeHandler={(data) => {
                          props.setFieldValue('businessName', data.value)
                          if (getLocationAddressState) {
                            for (let i = 0; i < getLocationAddressState.length; i++) {
                              if (data.value === getLocationAddressState[i].locationId) {
                                setLocationAddress(getLocationAddressState[i].address)
                              }
                            }
                          }
                        }}
                      />
                    </div>

                    <div className="equipment-requirements-wrapper mb-20">
                      <div className="label-heading">
                        <p>Loading Requirements<span className="star">*</span></p>
                      </div>
                      <div className="requirements-checkbox pl-0">
                        {loadingReqList?.map((value, index) => (
                          <Field
                            component={RadioButton}
                            name="loadingReq"
                            id={value.value}
                            defaultValue={loadingReqList[0].value}
                            onSelect={(e) => {
                              let tempValue = props.values.loadingReq === e.target?.value ? '' : e.target?.value
                              setFieldValue('loadingReq', tempValue)
                            }}
                            label={value.label}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div className="loan-detail-wrapper">
                        <div className="responsive-mb-32" style={{ position: 'relative' }}>
                          <div className="label-heading label-heading-lots">
                            <p>Load Details<span className="star">*</span></p>
                          </div>
                          {props.values?.reqPickupQuantity !== '' && <span className="qty-label">Estimated Quantity</span>}
                          <NumberInput
                            name='reqPickupQuantity'
                            placeholder="Estimated Quantity"
                            maxLength="4"
                            maxQuantity={9999}
                            decimalScale={0}
                            showErrorMessages={true}
                            onChangeHandler={(value) => {
                            }}
                          />
                        </div>
                        <div className="responsive-mb-32 ">
                          <div className="label-heading label-heading-lots">
                            <p style={{ textAlign: 'center' }}>Preferred Pickup Date<span className="star">*</span></p>
                          </div>
                          <DatePickerStyled>
                            <DatePickerPTPlus
                              name={`ptplusOrderReqPickupDate`}
                              placeholderText=""
                              type="createOrder"
                              selectedDate={props?.values?.ptplusOrderReqPickupDate}
                              callBackFun={(msg) => {
                                setErrorMessage(msg)
                              }}
                            />
                            {errorMessage && <p className="error-message" style={{ "margin-top": "5px" }}>Invalid Date</p>}
                          </DatePickerStyled>
                        </div>

                        <div>
                          <div className="label-heading label-heading-lots">
                            <p style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Preferred Pickup Appointment Window<span className="star">*</span></p>
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                            <div className="responsive-mb-32" style={{ position: 'relative' }}>
                              <span className="other-label">From</span>
                              <TimePickerInput
                                className="responsive"
                                name='appFromTime'
                                edit={props.values.appFromTime}
                                showErrorMessages={true}
                                // fromValue={props.values.appt}
                                toValue={props.values.appToTime}
                                selectedValue={props.values.appFromTime}
                                onChangeHandler={(time) => {
                                  setLastChangedTime('fromTime')
                                }}
                              />
                              {lastChangedTime === 'fromTime' && isTimeErrorCheck(props)}
                            </div>
                            <div className="responsive-mb-32" style={{ position: 'relative' }}>
                              <span className="other-label">To</span>
                              <TimePickerInput
                                className="responsive"
                                name='appToTime'
                                edit={props.values.appToTime}
                                // endTime="23:00"
                                fromValue={props.values.appFromTime}
                                // toValue={props.values.apptTo}
                                showErrorMessages={true}
                                selectedValue={props.values.appToTime}
                                onChangeHandler={(time) => {
                                  setLastChangedTime('toTime')
                                }}
                              />
                              {lastChangedTime === 'toTime' && isTimeErrorCheck(props)}
                            </div>
                          </div>
                        </div>
                        <div className="responsive-mb-32">
                          <TextInput
                            className="responsive"
                            name='poNumber'
                            placeholder="PO#"
                            inputType={"poNumber"}
                            maxLength='20'
                            showErrorMessages={true}
                          />
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="loan-detail-wrapper comment-section">
                        <div className="responsive-mb-32">
                          <div className="label-heading">
                            <p>Comments</p>
                          </div>
                          <TextArea
                            name='comments'
                            maxLength='200'
                            showErrorMessages={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </InputFieldsWrapper>
            </div>

            <Footer className="button-wrapper">
              {editedValues ?
                <button
                  className={`update-button ${checkDisable(props) && 'disabled-button'}`}
                  onClick={() => {
                    formSubmit(props)
                  }}
                  disabled={checkDisable(props)}
                >
                  Update Pickup Request
                </button>
                :
                <>
                  <button className="reset-button" onClick={() => resetFields(props)}>Reset</button>
                  <button
                    className={`submit-button ${checkDisable(props) && 'disabled-button'}`}
                    onClick={() => {
                      formSubmit(props)
                    }}
                    disabled={checkDisable(props)}
                  >
                    Create Request
                  </button>
                </>
              }
            </Footer>

          </FormWrapper>
        </Form>
      </>
    );
  };

  if (!storedData?.data?.isEnablePtPlusFeature) {
    dispatch(logoutClearRedux());
    localStorage.clear();
    history.push('/sign-in')
    window.location.reload(false);
  }

  return (
    <Layout pageType="PtPlusPage" topBarViewMobile={'hide'}>
      {(loaderVisible || loader) && <Spinner />}
      <div>
        <div style={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px 0px' }}>
          <TopHeader>
            <h6>{editedValues ? 'Update Pickup Order' : 'New Pickup Order'}</h6>
          </TopHeader>
        </div>
        <Container>
          <Wrapper>
            <Formik
              initialValues={getPostInitialValues()}
              validationSchema={VALIDATION_SCHEMA()}
              onSubmit={() => { }}
            >
              {(props) => {
                const { isValid, dirty, setFieldValue } = props;
                setEditedValuesFunction(props)
                return (
                  <>
                    {formFields(props, isValid, dirty, setFieldValue)}
                  </>
                );
              }}
            </Formik>
          </Wrapper>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={modalTitle}
            content={modalContent}
            link={modalLink}
            alertType={alertType}
            className="alert-msg-container"
            InnerClassName="alert-msg"
            callBackAlert={(val) => {
              if (val === "success") history.push('/ptplus-order-details')
              else toggleModal()
            }}
          />
        </Container>

      </div>
    </Layout>
  )
};

export default PickupOrderRequest;
